module.exports = __webpack_public_path__ + "static/media/import.537d0520.jpg";